import { Component, ErrorInfo, ReactNode } from 'react';

type Props = { children: ReactNode; onError: () => void };
type State = { hasError: boolean };

export default class SceneErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  componentDidCatch(_error: Error, _info: ErrorInfo) {
    this.props.onError();
  }

  render() {
    return this.state.hasError ? null : this.props.children;
  }
}
